module.exports = __webpack_public_path__ + "img/monitoring-bulldozer-green.3e02c04d.svg";